import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { MaterialCard } from '@learningblocks/storybook-components';
import {NoteBanner} from '@learningblocks/storybook-components';

// gel: ppe images
import Lab_Coat from './img/gel/ppe/Lab_Coat.svg'
import Protective_Gloves from './img/gel/ppe/Protective_Gloves.svg'
import Safety_Goggles from './img/gel/ppe/Safety_Goggles.svg'
import UV_Protective_Face_Shield from './img/gel/ppe/UV-Protective_Face_Shield.svg'

import PCR_product_X from './img/gel/PCR_product_X.svg'
import Balancing_Tube from './img/gel/Balancing_tube.svg'
import FiveX_loading_dye from './img/gel/FiveX_loading_dye.svg'
import hundred_bp_dna_ladder_marker from './img/gel/hundred_bp_dna_ladder_marker.svg'
import Sodium_Borate_Buffer from './img/gel/Sodium_Borate_Buffer.svg'
import Agarose_Gel from './img/gel/l2_material/gel_electro_equipment/Agarose_Gel.svg'
import Timer from './img/gel/Timer.svg'
import Gel_Electrophoresis_Box from './img/gel/l2_material/gel_electro_equipment/Electrophoresis_Box.svg'
import Power_Supply_Leads from './img/gel/l2_material/gel_electro_equipment/Power_Supply_Leads.svg'
import Power_Supply from './img/gel/l2_material/gel_electro_equipment/Power_Supply.svg'
import Transilluminator from './img/gel/l2_material/gel_electro_equipment/Transilluminator.svg'
import Centrifuge_Rotor_Adapters from './img/gel/Centrifuge_Rotor_Adapters.svg'
import Rotor_Adapters from  './img/gel/Centrifuge_Rotor_Adapters.svg'
import Microcentrifuge from './img/gel/l2_material/other_materials/Microcentrifuge.svg'

// gel : level 2 - materials - reagents
import alex_pcr_product_a from './img/gel/l2_material/alex_pcr_product_a.svg'
import jamie_pcr_product_j from './img/gel/l2_material/jamie_pcr_product_j.svg'
import lee_pcr_product_l from './img/gel/l2_material/lee_pcr_product_l.svg'
import small_balancing_tube_st from './img/gel/l2_material/small_balancing_tube_st.svg'
import large_balancing_tube_lt from './img/gel/l2_material/large_balancing_tube_lt.svg'
import Restriction_Enzyme_Haelli_RE from './img/gel/l2_material/Restriction_Enzyme_Haelli_RE.svg'
import Loading_Dye_LD from './img/gel/l2_material/Loading_Dye_LD.svg'
import Hundered_b_DNA_Ladder_Marker_M from './img/gel/l2_material/Hundered_b_DNA_Ladder_Marker_M.svg'
import oneX_Sodium_Borate_Buffer from './img/gel/l2_material/oneX_Sodium_Borate_Buffer.svg'
import BB_Positive_Control from './img/gel/l2_material/BB_Positive_Control.svg'

// gel : level 2 - materials - reagents
import Empty_Tube from './img/gel/l2_material/Empty_Tube.svg'
import Marker_Pen from './img/gel/l2_material/other_materials/Marker_Pen.svg'
import Floating_Tube_Rack from './img/gel/l2_material/restriction_enzyme_digest_equipment/Floating_Tube_Rack.svg'
import Water_Bath from './img/gel/l2_material/restriction_enzyme_digest_equipment/Water_Bath.svg'

// l3 material
import Lab_Partner_1_PCR_Product from './img/gel/l3_material/Lab_Partner_1_PCR_Product.svg'
import Lab_Partner_2_PCR_Product from './img/gel/l3_material/Lab_Partner_2_PCR_Product.svg'
import Lab_Partner_3_PCR_Product from './img/gel/l3_material/Lab_Partner_3_PCR_Product.svg'
import Lab_Partner_4_PCR_Product from './img/gel/l3_material/Lab_Partner_4_PCR_Product.svg'
import Lab_Partner_5_PCR_Product from './img/gel/l3_material/Lab_Partner_5_PCR_Product.svg'
import Loading_Dye_LD_3 from './img/gel/l3_material/Loading_Dye_LD.svg'
import One_Hundred_bp_DNA_Ladder_M from './img/gel/l3_material/One_Hundred_bp_DNA_Ladder_M.svg'
import Restriction_Enzyme_HaeIII_RE from './img/gel/l3_material/Restriction_Enzyme_HaeIII_RE.svg'
import Balancing_Tube_0_2ml_ST from './img/gel/l3_material/Balancing_Tube_0_2ml_ST.svg'
import Balancing_Tube_1_5ml_LT from './img/gel/l3_material/Balancing_Tube_1_5ml_LT.svg'


import Biohazardous_Waste from './img/Biohazardous_Waste.svg'
import Trash from './img/Trash.svg'
import Ice_Bucket from './img/Ice_Bucket.svg'
// import Microcentrifuge from './img/Microcentrifuge.svg'
import Thermocycler from './img/Thermocycler.svg'
import DNTPs from './img/dNTPs.svg'
import Taq_DNA_Polymerase from './img/Taq_DNA_Polymerase.svg'
import Forward_Primer from './img/Forward_Primer.svg'
import Reverse_Primer from './img/Reverse_Primer.svg'
import Primer_Mix_of_Primers_1_and_6 from './img/Primer_Mix_of_Primers_1_and_6.svg'
import Primer_Mix_of_Primers_2_and_5 from './img/Primer_Mix_of_Primers_2_and_5.svg'
import Primer_Mix_of_Primers_3_and_4 from './img/Primer_Mix_of_Primers_3_and_4.svg'
import Buffer from './img/Buffer.svg'
import Gene_X_Normal_Length_Control_DNA from './img/Gene_X_Normal_Length_Control_DNA.svg'
import Gene_X_Shorter_Length_Control_DNA from './img/Gene_X_Shorter_Length_Control_DNA.svg'
import Prokaryotic_Control_DNA from './img/Prokaryotic_Control_DNA.svg'
import DNase_Free_Water from './img/DNase_Free_Water.svg'
import Extracted_Human_DNA from './img/Extracted_Human_DNA.svg'
import Control_1_Thermocycler from './img/Control_1_Thermocycler.svg'
import Control_2_Thermocycler from './img/Control_2_Thermocycler.svg'
import Control_3_Thermocycler from './img/Control_3_Thermocycler.svg'
import Control_4_Thermocycler from './img/Control_4_Thermocycler.svg'
import Sample_Thermocycler from './img/Sample_Thermocycler.svg'
import Master_Mix from './img/Master_Mix.svg'
import P2_Tip_Box from './img/P2_Tip_Box.svg'
import P20_Tip_Box from './img/P20_Tip_Box.svg'
import P200_Tip_Box from './img/P200_Tip_Box.svg'
import P1000_Tip_Box from './img/P1000_Tip_Box.svg'
import P2_Pipette from './img/P2_Micropipette.svg'
import P20_Pipette from './img/P20_Micropipette.svg'
import P200_Pipette from './img/P200_Micropipette.svg'
import P1000_Pipette from './img/P1000_Micropipette.svg'
import Heat_block from './img/Heat_Block.svg'

const ImageList = {

  // gel : level 2 - materials - reagents
  alex_pcr_product_a: alex_pcr_product_a,
  jamie_pcr_product_j: jamie_pcr_product_j,
  lee_pcr_product_l: lee_pcr_product_l,
  small_balancing_tube_st: small_balancing_tube_st,
  large_balancing_tube_lt: large_balancing_tube_lt,
  Restriction_Enzyme_Haelli_RE: Restriction_Enzyme_Haelli_RE,
  Loading_Dye_LD: Loading_Dye_LD,
  Hundered_b_DNA_Ladder_Marker_M: Hundered_b_DNA_Ladder_Marker_M,
  oneX_Sodium_Borate_Buffer: oneX_Sodium_Borate_Buffer,

    // gel : level 2 - materials - reagents
  Empty_Tube: Empty_Tube,
  Empty_Tube_1: Empty_Tube,
  Empty_Tube_2: Empty_Tube,
  Empty_Tube_3: Empty_Tube,
  Empty_Tube_4: Empty_Tube,
  Empty_Tube_5: Empty_Tube,
  Marker_Pen: Marker_Pen,
  Floating_Tube_Rack: Floating_Tube_Rack,
  Water_Bath: Water_Bath,

  PCR_product_X: PCR_product_X,
  Balancing_Tube: Balancing_Tube,
  FiveX_loading_dye: FiveX_loading_dye,
  hundred_bp_dna_ladder_marker: hundred_bp_dna_ladder_marker,
  Sodium_Borate_Buffer: Sodium_Borate_Buffer,
  Agarose_Gel: Agarose_Gel,
  Gel_Electrophoresis_Box: Gel_Electrophoresis_Box,
  Power_cables: Power_Supply_Leads,
  Power_Supply: Power_Supply,
  Transilluminator:Transilluminator,
  Centrifuge_Rotor_Adapters: Centrifuge_Rotor_Adapters,
  Microcentrifuge_Gel: Microcentrifuge,

  // l3 material
  Lab_Partner_1_PCR_Product: Lab_Partner_1_PCR_Product,
  Lab_Partner_2_PCR_Product: Lab_Partner_2_PCR_Product,
  Lab_Partner_3_PCR_Product: Lab_Partner_3_PCR_Product,
  Lab_Partner_4_PCR_Product: Lab_Partner_4_PCR_Product,
  Lab_Partner_5_PCR_Product: Lab_Partner_5_PCR_Product,

  Loading_Dye_LD_3: Loading_Dye_LD_3,
  One_Hundred_bp_DNA_Ladder_M: One_Hundred_bp_DNA_Ladder_M,
  Restriction_Enzyme_HaeIII_RE: Restriction_Enzyme_HaeIII_RE,
  Balancing_Tube_0_2ml_ST: Balancing_Tube_0_2ml_ST,
  Balancing_Tube_1_5ml_LT: Balancing_Tube_1_5ml_LT,

  Biohazardous_Waste: Biohazardous_Waste,
  Biohazardous_Waste_container: Biohazardous_Waste,
  Trash: Trash,
  Ice_Bucket: Ice_Bucket,
  // Microcentrifuge: Microcentrifuge,
  Biohazardous_waste: Biohazardous_Waste,
  Trash: Trash,
  Ice_bucket: Ice_Bucket,
  Microcentrifuge: Microcentrifuge,


  Timer,



  Thermocycler: Thermocycler,
  dNTPs: DNTPs,
  Taq_DNA_polymerase: Taq_DNA_Polymerase,
  Forward_primer: Forward_Primer,
  Reverse_primer: Reverse_Primer,
  Primer_mix_of_primers_1_and_6: Primer_Mix_of_Primers_1_and_6,
  Primer_mix_of_primers_2_and_5: Primer_Mix_of_Primers_2_and_5,
  Primer_mix_of_primers_3_and_4: Primer_Mix_of_Primers_3_and_4,
  Buffer: Buffer,
  Gene_X_normal_length_control_DNA: Gene_X_Normal_Length_Control_DNA,
  Gene_X_shorter_length_control_DNA: Gene_X_Shorter_Length_Control_DNA,
  Prokaryotic_control_DNA: Prokaryotic_Control_DNA,
  DNase_free_water: DNase_Free_Water,
  Extracted_human_DNA: Extracted_Human_DNA,
  Control_1_thermocycler: Control_1_Thermocycler,
  Control_2_thermocycler: Control_2_Thermocycler,
  Control_3_thermocycler: Control_3_Thermocycler,
  Control_4_thermocycler: Control_4_Thermocycler,
  Sample_thermocycler: Sample_Thermocycler,
  Master_mix: Master_Mix,
  P2_Tip_Box: P2_Tip_Box,
  P20_Tip_Box: P20_Tip_Box,
  P200_Tip_Box: P200_Tip_Box,
  P1000_Tip_Box: P1000_Tip_Box,
  P2_Pipette: P2_Pipette,
  P20_Pipette: P20_Pipette,
  P200_Pipette: P200_Pipette,
  P1000_Pipette: P1000_Pipette,

  Lab_Coat,
  Protective_Gloves,
  Safety_Goggles,
  UV_Protective_Face_Shield,
  Rotor_Adapters,
  Heat_block,

  BB_Positive_Control: BB_Positive_Control,

}

export class MaterialsList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      materials: []
    };
  }

  getImage(type){
    return ImageList[type.replaceAll(" ", "_")]
  }
  capitalizeFirstLetter(label){
    return label?.charAt(0).toUpperCase() + label?.slice(1).toLowerCase()
  }

  getFullName(componentName, isSolutionTube, type, fullName, noCaseChange ){
    if(noCaseChange){
      return fullName
    }

    if(componentName == "Solution" && !isSolutionTube){
      return fullName;
    }

    if(componentName == "Pipette"){
      return this.capitalizeFirstLetter(type + " " + componentName);
    }

    if(componentName == "Tip Box"){
      return this.capitalizeFirstLetter(type + " " + componentName);
    }

    return ( componentName == "Solution" ) ? type : this.capitalizeFirstLetter(type)
  }
  getImageStyle(componentName){
    if(componentName == "Pipette"){
      return {width:'80%', margin: 'auto', marginBottom: '-21%', padding: '0',  paddingTop: '3%', height: '170px'}
    }
    if(componentName == "Tip Box"){
      return {width:'80%', margin: 'auto', padding: '15% 5%'}
    }
    return {width:'80%', margin: 'auto', padding: '5% 5%'}
  }

  buildComponent = (data, index) => {
    const { id, description, size, type, label, circleColor, solutionColor, isSolutionTube, fullName: name, glossaryTitle, glossaryContentId, circleOutline, noCaseChange } = data.props
    const solutionTubeProps = { size, type, label, circleColor, solutionColor, circleOutline }

    const componentName = data.component
    const isSolutionTubeProp =  componentName == "Solution" && isSolutionTube === true;
    const materialCardImage = ( componentName == "Pipette" ||  componentName == "Tip Box" ) ? this.getImage(type + " " +  componentName) : this.getImage(type);
    const fullName = this.getFullName(componentName, isSolutionTube, type, name, noCaseChange );
    const solutionTube = isSolutionTube ? solutionTubeProps : null;
    const imageStyle = this.getImageStyle(componentName);

    return <div style={{margin: '6px 2px'}}>
           <MaterialCard
              key={index}
              id={id}
              isSolutionTube={isSolutionTubeProp}
              solutionTube={solutionTube}
              imageStyle={imageStyle}
              image={materialCardImage}
              title={type}
              description={description}
              fullName= {fullName}
              glossaryTitle={glossaryTitle}
              contentID={glossaryContentId}
           />
    </div>
  }

  componentDidMount() {
    this.doCompPart(this.props.materials);
  }

    doCompPart = (data) => {
    let groupArr = []

    let grouping = {
      "Reagents": {
        "description": "Chemicals that can be used in this experiment.",
        "components": ["Solution"]
      },
      "Empty Tubes": {
        "description": "Used to hold solutions.",
        "components": ["Solution"]
      },
      "Micropipetting Equipment": {
        "description": "Used to measure small volumes.",
        "components": ["Pipettes", "Tip Boxes"]
      },
      "Restriction Enzyme Digest Equipment": {
        "description": "Used to perform the restriction enzyme DNA digestion.",
        "components": ["Ice Bucket", "Heat Block", "Timer" ]
      },
      "Gel Electrophoresis Equipment": {
        "description": "Used to sort molecules by size and charge.",
        "components": ["Agarose Gel", "Gel Electrophoresis Box", "Power Supply", "Power Cables", "Transilluminator"]
      },
      "Other Equipment": {
        "description": "",
        "components": ["Thermocycler", "Rotor Adapters", "Microcentrifuge", "Trash", "Biohazardous Waste container"]
      },
      "Personal Protective Equipment (PPE)": {
        "description": "Before starting in the lab, we have to make sure we are wearing PPE to protect our skin, eyes, and clothes.",
        "components": ["Lab Coat", "Safety Goggles", "UV Protective Face Shield", "Protective Gloves"]
      },
    }


    Object.keys(grouping).forEach((key, index) => {
        let compArr = []

        grouping[key].components.forEach((component) => {
          if(data.hasOwnProperty(component)){
            data[component].components.forEach((comp, index) => {
              if(key !== "Reagents" && key !== "Empty Tubes" || key == "Reagents" && comp.props.volume > 0 || key == "Empty Tubes" && comp.props.volume <= 0){
                compArr.push(this.buildComponent(comp, index));
              }
            })
          }
        });

        if(typeof compArr[0] != 'undefined'){
          groupArr.push(
            <div aria-label={key} key={index} className="Category">
              <h3 tabIndex={0} aria-label={key} className="CategoryHeading">{key}</h3>
              <h6 tabIndex={0} style={{margin: '-8px 0 16px 0'}}>{grouping[key].description}</h6>
              <div aria-label={key} className="Group">
                {compArr}
              </div>
            </div>
          )
        }
    })


    this.setState({
      materials: groupArr
    });
  };

  render() {
    return(
      <div className={this.props.className}>
        <div className="Materials">{this.state.materials}</div>
      </div>
    )
  }

}
MaterialsList.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  className: PropTypes.string,
  materials: PropTypes.array.isRequired
};

MaterialsList.defaultProps = {
  className: 'materialsList',
};
